import { IPosition } from '@medely/types';

export const BULK_CREATE_LOCATION_POSITION_IDS: IPosition['id'][] = [20, 24, 25];

export const RATE_ADJUSTMENT_CENTS = 10;
